import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button } from 'react-bootstrap';
import logoLight from 'assets/img/icons/logo-light.png';
import useSettingsMountEffect from 'hooks/useSettingsMountEffect';

const NewDashboardAnnouncement = () => {
  useSettingsMountEffect({
    disableNavigationType: true,
    disableHorizontalNavbarAppearance: true,
    disableVerticalNavbarAppearance: true,
    disableHorizontalNavbarShape: true
  });

  const navigate = useNavigate();
  const [showConfetti, setShowConfetti] = useState(false);
  
  useEffect(() => {
    // Show confetti after 1 second for surprise effect
    const timer = setTimeout(() => {
      setShowConfetti(true);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleRedirect = () => {
    navigate('/');
  };

  return (
    <div className="px-3">
      <Row className="min-vh-100 flex-center p-5">
        <Col xs={12} xl={10} xxl={8}>
          <Row className="justify-content-center align-items-center g-5">
            {/* Logo and Header */}
            <Col xs={12} className="text-center mb-4">
              <div className="mb-4">
                <img 
                  src={logoLight}
                  alt="Wamia Logo"
                  width={256}
                  className="img-fluid mb-4"
                />
                <h1 className="fw-bolder mb-3" style={{ color: '#FF7A00' }}>
                  سعداء برشا باستقبالك في منصّتك الجديدة
                </h1>
              </div>
            </Col>

            {/* Button with simple surprise animation */}
            <Col xs={12} className="text-center mb-5">
              <Button 
                onClick={handleRedirect}
                className={`modern-btn ${showConfetti ? 'modern-btn--confetti' : ''}`}
              >
                <span className="btn-content">Cliquez ici !</span>
                <span className="btn-arrow">➔</span>
                <span className="btn-ripple"></span>
              </Button>
              
              {/* Confetti effect */}
              {showConfetti && (
                <div className="confetti-container">
                  {[...Array(50)].map((_, i) => (
                    <div 
                      key={i} 
                      className="confetti"
                      style={{
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 3}s`,
                        backgroundColor: ['#FF7A00', '#FFA41B', '#1C3879', '#4158D0', '#FFD700'][Math.floor(Math.random() * 5)]
                      }}
                    />
                  ))}
                </div>
              )}
            </Col>

            <Col xs={12} lg={10} className="text-center">
              {/* Tunisian Arabic Section */}
              <div className="mb-5 p-4 bg-white rounded shadow-sm">
                <p className="fs-5 mb-3" style={{color: '#FF7A00', fontWeight: 'bold'}}>
                 ! مرحبا بيك 
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  عملنا على تطوير الواجهة باش تكون أكثر سلاسة ووضوح، وتسهّل عليك إدارة نشاطك بكل كفاءة. إن شاء الله تكون تجارة مزدهرة
                </p>
                
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  : إذا تحتاج أي مساعدة أو عندك استفسار، فريقنا حاضر ديما
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  <span style={{marginRight: '10px', color: '#FF7A00', fontSize: '1.1rem'}}>📞</span>
                  <a href="tel:36111222" 
                     style={{
                       color: '#333', 
                       textDecoration: 'none', 
                       transition: 'color 0.3s ease'
                     }}
                     className="contact-link">36111222</a>
                </p>
                <p className="mb-3" style={{fontSize: '1.1rem'}}>
                  <strong style={{marginRight: '8px'}}>✉️</strong>
                  <a href="mailto:srm@wamia.tn" 
                     style={{
                       color: '#333', 
                       textDecoration: 'none', 
                       transition: 'color 0.3s ease'
                     }}
                     className="contact-link">srm@wamia.tn</a>
                </p>
                <p className="mb-2 text-center" style={{fontSize: '1.1rem'}}>
                  .شكراً على ثقتك المتواصلة و وجودك معانا
                </p>
              </div>

              {/* French Section */}
              <div className="mb-5 p-4 bg-white rounded shadow-sm">
                <p className="fs-5 mb-3" style={{color: '#FF7A00', fontWeight: 'bold'}}>
                  Bienvenue !
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  Nous avons développé l'interface pour qu'elle soit plus fluide et claire, vous permettant de gérer votre activité avec efficacité. Nous vous souhaitons un commerce florissant.
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  Si vous avez besoin d'aide ou avez des questions, notre équipe est toujours disponible:
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  <span style={{marginRight: '10px', color: '#FF7A00', fontSize: '1.1rem'}}>📞</span>
                  <a href="tel:36111222" 
                     style={{
                       color: '#333', 
                       textDecoration: 'none', 
                       transition: 'color 0.3s ease'
                     }}
                     className="contact-link">36111222</a>
                </p>
                <p className="mb-3" style={{fontSize: '1.1rem'}}>
                  <strong style={{marginRight: '8px'}}>✉️</strong>
                  <a href="mailto:srm@wamia.tn" 
                     style={{
                       color: '#333', 
                       textDecoration: 'none', 
                       transition: 'color 0.3s ease'
                     }}
                     className="contact-link">srm@wamia.tn</a>
                </p>
                <p className="mb-2 text-center" style={{fontSize: '1.1rem'}}>
                  Merci pour votre confiance continue et votre présence avec nous.
                </p>
              </div>

              {/* English Section */}
              <div className="mb-5 p-4 bg-white rounded shadow-sm">
                <p className="fs-5 mb-3" style={{color: '#FF7A00', fontWeight: 'bold'}}>
                  Welcome!
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  We have developed the interface to be more fluid and clear, allowing you to manage your activity efficiently. We wish you a prosperous business.
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  If you need any assistance or have any questions, our team is always available:
                </p>
                <p className="mb-2" style={{fontSize: '1.1rem'}}>
                  <span style={{marginRight: '10px', color: '#FF7A00', fontSize: '1.1rem'}}>📞</span>
                  <a href="tel:36111222" 
                     style={{
                       color: '#333', 
                       textDecoration: 'none', 
                       transition: 'color 0.3s ease'
                     }}
                     className="contact-link">36111222</a>
                </p>
                <p className="mb-3" style={{fontSize: '1.1rem'}}>
                  <strong style={{marginRight: '8px'}}>✉️</strong>
                  <a href="mailto:srm@wamia.tn" 
                     style={{
                       color: '#333', 
                       textDecoration: 'none', 
                       transition: 'color 0.3s ease'
                     }}
                     className="contact-link">srm@wamia.tn</a>
                </p>
                <p className="mb-2 text-center" style={{fontSize: '1.1rem'}}>
                  Thank you for your continued trust and presence with us.
                </p>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* CSS for the surprise animation */}
      <style>
        {`
          .animate-surprise {
            animation: bounce-scale 0.5s ease;
          }
          
          @keyframes bounce-scale {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.2);
            }
          }
          
          .confetti-container {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            pointer-events: none;
            z-index: 1000;
          }
          
          .confetti {
            position: absolute;
            width: 10px;
            height: 10px;
            top: -10px;
            border-radius: 0;
            opacity: 0.7;
            animation: confetti-fall 3s linear forwards;
            transform: rotate(45deg);
          }
          
          @keyframes confetti-fall {
            0% {
              top: -10px;
              transform: rotate(45deg) translateX(0);
              opacity: 1;
            }
            25% {
              transform: rotate(90deg) translateX(20px);
            }
            50% {
              transform: rotate(180deg) translateX(-20px);
            }
            75% {
              transform: rotate(270deg) translateX(20px);
            }
            100% {
              top: 100%;
              transform: rotate(360deg) translateX(-20px);
              opacity: 0;
            }
          }
          
          .contact-link:hover {
            color: #FF7A00 !important;
            text-decoration: underline !important;
          }
          
          /* Base modern button */
          .modern-btn {
            /* Size & spacing */
            padding: 14px 36px;
            font-size: 1.1rem;
            font-weight: 600;
          
            /* Shape */
            border: none;
            border-radius: 999px;
            outline: none;
            overflow: hidden;
          
            /* Background gradient */
            background: linear-gradient(
              135deg,
              #ff7a00 0%,
              #ffa41b 100%
            );
          
            color: #fff;
            text-transform: uppercase;
            letter-spacing: 0.8px;
          
            /* Shadow & transition */
            box-shadow: 
              0 4px 8px rgba(0, 0, 0, 0.1),
              0 0 0 rgba(255, 122, 0, 0);
            transition:
              transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275),
              box-shadow 0.3s ease,
              background 0.3s ease;
          
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: relative;
          }
          
          .btn-content {
            position: relative;
            z-index: 2;
          }
          
          .btn-arrow {
            margin-left: 8px;
            font-size: 1.2rem;
            transition: transform 0.3s ease;
            position: relative;
            z-index: 2;
            opacity: 0.7;
          }
          
          .btn-ripple {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            background: rgba(255, 255, 255, 0.4);
            border-radius: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
            opacity: 0;
          }
          
          /* Hover state: lift + deepen shadow + glow */
          .modern-btn:hover {
            transform: translateY(-3px) scale(1.02);
            box-shadow: 
              0 8px 20px rgba(0, 0, 0, 0.15),
              0 0 25px rgba(255, 122, 0, 0.4);
          }
          
          .modern-btn:hover .btn-arrow {
            transform: translateX(4px);
            opacity: 1;
          }
          
          /* Active (pressed) state */
          .modern-btn:active {
            background: linear-gradient(
              135deg,
              #e46900 0%,
              #db8b14 100%
            );
            transform: translateY(1px);
            box-shadow: 
              0 3px 6px rgba(0, 0, 0, 0.1),
              0 0 15px rgba(255, 122, 0, 0.3);
          }
          
          /* Click ripple animation */
          .modern-btn:active .btn-ripple {
            animation: ripple 0.8s ease-out;
          }
          
          @keyframes ripple {
            0% {
              width: 0;
              height: 0;
              opacity: 0.6;
            }
            100% {
              width: 300px;
              height: 300px;
              opacity: 0;
            }
          }
          
          /* Focus state: subtle outline (for accessibility) */
          .modern-btn:focus {
            box-shadow: 
              0 4px 8px rgba(0, 0, 0, 0.1),
              0 0 0 3px rgba(255, 164, 27, 0.4);
          }
          
          /* Optional "confetti" animation modifier */
          @keyframes confettiPop {
            0%   { transform: scale(1) rotate(0deg); }
            25%  { transform: scale(1.05) rotate(1deg); }
            50%  { transform: scale(1.12) rotate(-1deg); }
            75%  { transform: scale(1.05) rotate(1deg); }
            100% { transform: scale(1) rotate(0deg); }
          }
          
          .modern-btn--confetti {
            animation: confettiPop 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          }
          
          /* Subtle shine effect */
          .modern-btn::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(
              90deg,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.3) 50%,
              rgba(255, 255, 255, 0) 100%
            );
            transform: skewX(-15deg);
            transition: all 0.6s ease;
            z-index: 1;
          }
          
          .modern-btn:hover::before {
            left: 100%;
            transition: all 0.6s ease;
          }
          
          /* Smaller responsiveness tweak */
          @media (max-width: 576px) {
            .modern-btn {
              padding: 12px 28px;
              font-size: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default NewDashboardAnnouncement;
